import React from 'react'
import { NumberText } from '../../../Global'

export const TableDataCellUniqueReach = ({
  dataValue,
}: {
  dataValue?: number
}) => {
  return <NumberText value={Number(dataValue)} maximumFractionDigits={1} />
}
